(function(){
  function boot(){
  if (window.__pdpFactoryBooted) return;
  window.__pdpFactoryBooted = true;
  function safe(fn){ try { fn(); } catch (e) { console.error('[pdp-factory]', e); } }
  // Seeded, not random: a shopper who reloads and sees a different number stops believing
  // every number on the page. Shared at boot() scope so resolveVariant() and the clock loop
  // below both use the same seed.
  function seedHash(s){ var h = 0; for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; } return h; }
  var fomoDayKey = Math.floor(Date.now() / 86400000);
  var rootForFmt = document.querySelector('#pdp-factory');
  if (!rootForFmt) return;
  var moneyFormat = rootForFmt.getAttribute('data-money-format') || '${{amount}}';
  function money(cents){ return moneyFormat.replace(/<[^>]*>/g,'').replace(/\{\{[^}]+\}\}/, (cents/100).toFixed(2)); }

  // Event delegation on `document`, survives Shopify re-rendering this section's
  // markup (theme editor live preview, cart/section AJAX updates) without needing
  // to re-attach listeners, since delegation resolves the target at click time.

  // ---- Gallery: thumbnails + swipe dots ----
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#pdp-factory #gThumbs button');
    if (!btn) return;
    safe(function(){
      var root = btn.closest('#pdp-factory');
      var track = root.querySelector('#gTrack');
      var i = parseInt(btn.dataset.i, 10);
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    });
  });
  document.addEventListener('scroll', function(e){
    var track = e.target;
    if (!track || track.id !== 'gTrack') return;
    safe(function(){
      var root = track.closest('#pdp-factory');
      var i = Math.round(track.scrollLeft / track.clientWidth);
      root.querySelectorAll('#gThumbs button').forEach(function(b,j){ b.classList.toggle('active', j===i); });
      root.querySelectorAll('#gDots span').forEach(function(d,j){ d.classList.toggle('active', j===i); });
    });
  }, true);

  // ---- Tier selector ----
  // Resolves the [[PCT_OFF]] token inside every tier note against that tier's own
  // total/compare, which are already in the active market's currency. Re-run on every
  // tier or variant change so the % never contradicts the badge above the selector.
  function refreshTierNotes(root){
    root.querySelectorAll('.tier').forEach(function(t){
      var noteEl = t.querySelector('.t-note');
      if (!noteEl) return;
      var tpl = noteEl.getAttribute('data-note-tpl');
      if (!tpl || tpl.indexOf('[[PCT_OFF]]') === -1) return;
      var tot = parseFloat(t.dataset.total);
      var cmp = parseFloat(t.dataset.compare);
      var pct = (cmp > tot && cmp > 0) ? Math.round((1 - tot / cmp) * 100) : 0;
      noteEl.textContent = tpl.split('[[PCT_OFF]]').join(pct);
    });
  }

  function selectTier(el){
    var root = el.closest('#pdp-factory');
    var tiers = root.querySelectorAll('.tier');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var sPriceEl = root.querySelector('[data-s-price]');
    var sCompareEl = root.querySelector('[data-s-compare]');
    var offerLabelEl = root.querySelector('[data-offer-label]');
    var qtyInput = root.querySelector('[data-quantity]');
    var giftCards = root.querySelectorAll('.gcard');

    tiers.forEach(function(t){ t.classList.remove('selected'); });
    el.classList.add('selected');
    var input = el.querySelector('input');
    if (input) input.checked = true;

    var total = parseFloat(el.dataset.total);
    var compare = parseFloat(el.dataset.compare);
    var paidQty = parseInt(el.dataset.paidQty, 10) || 1;

    var cartQty = parseInt(el.dataset.cartQty, 10) || paidQty;
    if (qtyInput) qtyInput.value = cartQty;
    if (priceEl) priceEl.textContent = money(total);
    if (sPriceEl) sPriceEl.textContent = money(total);
    if (compareEl) { if (compare > total) { compareEl.textContent = money(compare); compareEl.style.display=''; } else { compareEl.style.display='none'; } }
    if (sCompareEl) { if (compare > total) { sCompareEl.textContent = money(compare); sCompareEl.style.display=''; } else { sCompareEl.style.display='none'; } }
    if (offerLabelEl && compare > 0) { offerLabelEl.textContent = Math.round((1 - total/compare) * 100) + '% OFF'; }

    refreshTierNotes(root);

    var level = parseInt(el.dataset.level, 10) || 1;
    giftCards.forEach(function(g){
      var minLevel = parseInt(g.dataset.minLevel, 10) || 1;
      g.classList.toggle('locked', minLevel > level);
    });
    safe(function(){ toggleSplit(root, el.dataset.splitVariants === '1'); });
  }
  document.addEventListener('click', function(e){
    var tierEl = e.target.closest('#pdp-factory .tier');
    if (!tierEl) return;
    safe(function(){ selectTier(tierEl); });
  });

  // ---- Order bump: the real checkbox is visually hidden, so mirror its state onto the card.
  // Listening on `change` (not `click`) keeps the keyboard/label behaviour the browser already
  // gives us for free, instead of reimplementing it.
  document.addEventListener('change', function(e){
    var input = e.target.closest('#pdp-factory #pdpBump input[data-bump-variant]');
    if (!input) return;
    var card = input.closest('.bump');
    if (card) card.classList.toggle('checked', input.checked);
    // Un campo de personalizacion gated cuelga de este checkbox: se abre al tildarlo y el foco va
    // al input, porque tildar la placa sin escribir el nombre deja el pedido a medias.
    safe(function(){
      var root = input.closest('#pdp-factory');
      var box = root && root.querySelector('#pdpPerso[data-requires-bump="1"]');
      if (!box) return;
      box.classList.toggle('open', input.checked);
      if (input.checked) {
        var f = box.querySelector('#pdpPersoInput');
        if (f) { try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); } }
      } else {
        box.classList.remove('invalid');
      }
    });
  });
  // ---- Scroll a un ancla del factory (2026-08-08). Generico: cualquier elemento con
  // [data-scroll-to="<selector>"] scrollea ahi. Primer uso: la fomo-pill -> #tiers.
  // No usa scrollIntoView({behavior:'smooth'}) porque su duracion la fija el navegador y en un
  // salto largo se siente lento; aca la duracion es fija (520ms) con easeInOutCubic, que es lo
  // que Emilio pidio: "intermedio tirando a rapido pero no instantaneo".
  function scrollSuave(target, dur){
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    // La sticky-atc tapa el fondo del viewport, asi que el destino se corre para arriba y el
    // bloque queda visible entero, no pegado al borde.
    var offset = 90;
    var start = window.pageYOffset;
    var end = Math.max(0, start + target.getBoundingClientRect().top - offset);
    if (reduce || Math.abs(end - start) < 8) { window.scrollTo(0, end); return; }
    var t0 = null;
    var total = dur || 520;
    function step(ts){
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / total);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, start + (end - start) * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  // ---- Bumps secundarios: color-match con el host (2026-08-08). Mismo patron que
  // updateGiftColor pero por tarjeta, porque puede haber N bumps y cada uno con su propio map.
  function updateXbumpColor(root, optionName, value){
    root.querySelectorAll('.bump-lite[data-xbump-match-option]').forEach(function(card){
      if (card.dataset.xbumpMatchOption !== optionName) return;
      if (card.__xbMap === undefined) {
        var el = card.querySelector('.pdp-xbump-colormap-json');
        try { card.__xbMap = el ? JSON.parse(el.textContent) : null; } catch (e) { card.__xbMap = null; }
      }
      var entry = card.__xbMap && card.__xbMap[value];
      if (!entry) return;
      var input = card.querySelector('input[data-xbump-variant]');
      if (input) input.dataset.xbumpVariant = entry.id;
      var img = card.querySelector('.bump-img img');
      if (img && entry.image) img.src = entry.image;
      var zoom = card.querySelector('[data-zoom-src]');
      if (zoom && entry.zoom) zoom.dataset.zoomSrc = entry.zoom;
    });
  }

  // ---- Bumps secundarios (order_bumps, 2026-08-08): checkbox simple, sin gating ni split.
  // Handler propio en vez de tocar el de arriba: el primario dispara la apertura del campo de
  // personalizacion y estos no tienen nada que abrir.
  document.addEventListener('change', function(e){
    var xi = e.target.closest('#pdp-factory .bump-lite input[data-xbump-variant]');
    if (!xi) return;
    var card = xi.closest('.bump');
    if (card) card.classList.toggle('checked', xi.checked);
  });

  // Sync price / gifts / sticky to the default-selected tier on load
  safe(function(){
    document.querySelectorAll('#pdp-factory').forEach(function(root){
      var def = root.querySelector('.tier.selected') || root.querySelector('.tier');
      if (def) selectTier(def);
    });
  });

  // ---- Size / variant selector ----
  function getVariantsData(root){
    if (root.__pdpVariants) return root.__pdpVariants;
    var el = root.querySelector('#pdp-variants-json');
    if (!el) return null;
    try { root.__pdpVariants = JSON.parse(el.textContent); } catch (e) { root.__pdpVariants = []; }
    return root.__pdpVariants;
  }
  function selectedOptionValues(root){
    var values = [];
    root.querySelectorAll('#optGroups .opt-group').forEach(function(group){
      var pos = parseInt(group.dataset.optionPosition, 10);
      var sel = group.querySelector('.opt-value.selected');
      values[pos - 1] = sel ? sel.dataset.value : null;
    });
    return values;
  }
  function findVariant(variants, values){
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var matches = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] != null && v['option' + (j + 1)] !== values[j]) { matches = false; break; }
      }
      if (matches) return v;
    }
    return null;
  }
  function setCtaState(root, enabled, label){
    root.querySelectorAll('#ctaMain, #ctaSticky, [form="pdp-form"]').forEach(function(btn){
      btn.disabled = !enabled;
      btn.textContent = label || btn.dataset.defaultLabel || 'Add to cart';
    });
  }
  // FOMO stock badge (2026-08-06): driven by resolveVariant(), not by the 1s clock below,
  // so it updates the instant a size is picked instead of waiting for the next tick — and it
  // can see match.available to hide on a sold-out variant.
  function updateFomoStock(root, match){
    var wrap = root.querySelector('[data-fomo-stock]');
    if (!wrap) return;
    if (!match || match.available === false) { wrap.hidden = true; return; }
    var min = parseInt(wrap.dataset.min, 10) || 4, max = parseInt(wrap.dataset.max, 10) || 11;
    var n = min + (seedHash('s' + match.id + fomoDayKey) % Math.max(1, max - min + 1));
    var nEl = wrap.querySelector('[data-fomo-stock-n]');
    var fillEl = wrap.querySelector('[data-fomo-stock-fill]');
    if (nEl) nEl.textContent = n;
    if (fillEl) fillEl.style.width = Math.max(8, Math.round(n / (max + 4) * 100)) + '%';
    wrap.hidden = false;
  }
  function resolveVariant(root){
    var variants = getVariantsData(root);
    if (!variants || !variants.length) return;
    var values = selectedOptionValues(root);
    var match = findVariant(variants, values) || variants[0];
    var idInput = root.querySelector('[data-variant-id]');
    if (idInput) idInput.value = match.id;
    updateFomoStock(root, match);

    // properties[_Color] / properties[_Color Hex] (2026-08-05, revisado 2026-08-06): copia el
    // color elegido y su hex real (leido del propio punto de color, no reinventado) a los dos
    // inputs de propiedad. El "_" los oculta del carrito/checkout que ve el cliente (Shopify ya
    // muestra "Color: Army Green" solo, desde la variante) pero los deja en la orden/Admin, y el
    // hex es lo que pinta el punto de color real en el carrito. Sin grupo de color, quedan
    // disabled y no viaja nada.
    var colorProp = root.querySelector('[data-color-property]');
    var colorHexProp = root.querySelector('[data-color-hex-property]');
    if (colorProp) {
      var colorGroup = null;
      root.querySelectorAll('#optGroups .opt-group').forEach(function(g){
        var n = (g.dataset.optionName || '').toLowerCase();
        if (!colorGroup && g.dataset.isSize !== 'true' && n.indexOf('col') !== -1) colorGroup = g;
      });
      var sel = colorGroup && colorGroup.querySelector('.opt-value.selected');
      if (sel && sel.dataset.value) {
        colorProp.value = sel.dataset.value.toUpperCase();
        colorProp.disabled = false;
        if (colorHexProp) {
          var dot = sel.querySelector('.sw-dot');
          var hex = dot ? (dot.style.background || dot.style.backgroundColor) : '';
          colorHexProp.value = hex || '';
          colorHexProp.disabled = !hex;
        }
      } else {
        colorProp.value = '';
        colorProp.disabled = true;
        if (colorHexProp) { colorHexProp.value = ''; colorHexProp.disabled = true; }
      }
    }

    var compareForTiers = match.compare_at_price > match.price ? match.compare_at_price : match.price;
    root.querySelectorAll('.tier').forEach(function(t){
      var paidQty = parseInt(t.dataset.paidQty, 10) || 1;
      var shippedQty = parseInt(t.dataset.shippedQty, 10) || paidQty;
      // discount_pct (2026-08-08): mismo redondeo que Shopify Y que el Liquid — el descuento se
      // floorea POR UNIDAD (39.99 -15% cobra 34.00), o el precio parpadea contra el checkout.
      var tierDisc = parseInt(t.dataset.discountPct, 10) || 0;
      var tierTotal = match.price * paidQty;
      if (tierDisc > 0) tierTotal = (match.price - Math.floor(match.price * tierDisc / 100)) * paidQty;
      t.dataset.total = tierTotal;
      t.dataset.compare = compareForTiers * shippedQty;
    });

    var selectedTier = root.querySelector('.tier.selected') || root.querySelector('.tier');
    if (selectedTier) {
      selectTier(selectedTier);
    } else {
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var sPriceEl = root.querySelector('[data-s-price]');
      var sCompareEl = root.querySelector('[data-s-compare]');
      var offerLabelEl = root.querySelector('[data-offer-label]');
      if (priceEl) priceEl.textContent = money(match.price);
      if (sPriceEl) sPriceEl.textContent = money(match.price);
      var hasCompare = match.compare_at_price > match.price;
      if (compareEl) { if (hasCompare) { compareEl.textContent = money(match.compare_at_price); compareEl.style.display=''; } else { compareEl.style.display='none'; } }
      if (sCompareEl) { if (hasCompare) { sCompareEl.textContent = money(match.compare_at_price); sCompareEl.style.display=''; } else { sCompareEl.style.display='none'; } }
      if (offerLabelEl && hasCompare) { offerLabelEl.textContent = Math.round((1 - match.price / match.compare_at_price) * 100) + '% OFF'; }
    }

    setCtaState(root, match.available !== false, match.available === false ? 'Sold out' : null);
  }
  function getSizeInfoData(root){
    if (root.__pdpSizeInfo !== undefined) return root.__pdpSizeInfo;
    var el = root.querySelector('#pdp-size-info-json');
    if (!el) { root.__pdpSizeInfo = null; return null; }
    try { root.__pdpSizeInfo = JSON.parse(el.textContent); } catch (e) { root.__pdpSizeInfo = null; }
    return root.__pdpSizeInfo;
  }
  function getSizeBreedsData(root){
    if (root.__pdpSizeBreeds !== undefined) return root.__pdpSizeBreeds;
    var el = root.querySelector('#pdp-size-breeds-json');
    if (!el) { root.__pdpSizeBreeds = null; return null; }
    try { root.__pdpSizeBreeds = JSON.parse(el.textContent); } catch (e) { root.__pdpSizeBreeds = null; }
    return root.__pdpSizeBreeds;
  }
  function updateGroupLabel(group, value){
    if (group.dataset.isSize !== 'true') {
      if (group.querySelector('.opt-value.sw')) {
        var swLabel = group.querySelector('[data-opt-label]');
        if (swLabel) swLabel.textContent = (group.dataset.optionName || '').toUpperCase() + ': ' + value;
      }
      return;
    }
    var label = group.querySelector('[data-opt-label]');
    if (!label) return;
    var root = group.closest('#pdp-factory');
    var info = getSizeInfoData(root);
    var name = group.dataset.optionName || 'Size';
    var text = name.toUpperCase() + ': ' + value;
    if (info && info[value]) text += ' - ' + info[value];
    label.textContent = text;
    // Razas del talle elegido (2026-08-08). Se actualiza junto con el label y no aparte: son la
    // misma respuesta a "¿este talle es el de mi perro?", medida y por raza.
    var breedsEl = group.querySelector('[data-opt-breeds]');
    if (breedsEl) {
      var breeds = getSizeBreedsData(root);
      breedsEl.textContent = (breeds && breeds[value]) ? breeds[value] : '';
    }
  }
  // ---- Free gift: swap color to match the host option (e.g. leash color follows harness color) ----
  function getGiftColormap(root){
    if (root.__pdpGiftColormap !== undefined) return root.__pdpGiftColormap;
    var el = root.querySelector('#pdp-gift-colormap-json');
    if (!el) { root.__pdpGiftColormap = null; return null; }
    try { root.__pdpGiftColormap = JSON.parse(el.textContent); } catch (e) { root.__pdpGiftColormap = null; }
    return root.__pdpGiftColormap;
  }
  function updateGiftColor(root, optionName, value){
    var giftEl = root.querySelector('#pdpGift[data-gift-match-option]');
    if (!giftEl || giftEl.dataset.giftMatchOption !== optionName) return;
    var map = getGiftColormap(root);
    var entry = map && map[value];
    if (!entry) return;
    giftEl.dataset.giftVariant = entry.id;
    var img = giftEl.querySelector('.gl-img img');
    if (img && entry.image) img.src = entry.image;
  }
  // ---- 2 Dogs (split_variants, 08/08): Dog 2 = clon runtime del selector; sus botones pierden
  // .opt-group a proposito para que el handler principal no pise la variante de Dog 1.
  // Tabs (08/08, feedback de Valen): en vez de apilar los dos selectores, una barra "Dog 1 / Dog 2"
  // muestra uno por vez, con el nombre tipeado como label del tab y el input adentro del panel.
  // El tab de cada perro lleva su nombre tipeado y un punto con SU color elegido: asi el tab
  // inactivo sigue diciendo que hay adentro sin tener que abrirlo.
  function dogOptSelected(root, n, isSize){
    var sel = '[data-is-size="' + (isSize ? 'true' : 'false') + '"] .opt-value.selected';
    return n === 1
      ? root.querySelector('#optGroups .opt-group' + sel)
      : root.querySelector('#dog2Wrap .d2-group' + sel);
  }
  function dogColorHex(root, n){
    var sel = dogOptSelected(root, n, false);
    var dot = sel && sel.querySelector('.sw-dot');
    return dot ? (dot.style.background || dot.style.backgroundColor || '') : '';
  }
  function dogSize(root, n){
    var sel = dogOptSelected(root, n, true);
    return sel ? (sel.dataset.value || '') : '';
  }
  function updateDogTabs(root){
    var bar = root.querySelector('#dogTabs');
    if (!bar) return;
    [1, 2].forEach(function(n){
      var btn = bar.querySelector('[data-dog="' + n + '"]');
      if (!btn) return;
      var input = root.querySelector(n === 1 ? '#pdpPersoInput' : '#pdpPersoInput2');
      var name = input ? (input.value || '').trim() : '';
      btn.textContent = name ? (n + ' \u00b7 ' + name) : ('Dog ' + n);
      var hex = dogColorHex(root, n);
      if (hex) {
        var dot = document.createElement('span');
        dot.className = 't-dot';
        dot.style.background = hex;
        btn.insertBefore(dot, btn.firstChild);
      }
      var size = dogSize(root, n);
      if (size) {
        var sz = document.createElement('span');
        sz.className = 't-size';
        sz.textContent = size;
        btn.appendChild(sz);
      }
    });
  }
  // setDogTab NO mueve nodos: solo prende y apaga. La version anterior movia #pdpPerso dentro de
  // #optGroups y una excepcion ahi dejaba toggleSplit cortado a la mitad — la placa se quedaba en
  // "+$6.00", la correa sin el "2x" y el input de Dog 2 sin revelar. Medido el 08/08.
  function setDogTab(root, n){
    var split = root.classList.contains('pdp-split');
    if (!split) n = 1;
    root.dataset.dogTab = n;
    var bar = root.querySelector('#dogTabs');
    if (bar) bar.querySelectorAll('button').forEach(function(b){ b.classList.toggle('on', b.dataset.dog === String(n)); });
    var og = root.querySelector('#optGroups');
    var p1 = root.querySelector('#pdpPerso');
    var w2 = root.querySelector('#dog2Wrap');
    // Sin split, Dog 1 SIEMPRE visible: es la PDP normal de un solo perro.
    if (og) og.hidden = split && n === 2;
    if (p1) p1.classList.toggle('tab-off', split && n === 2);
    if (w2) w2.hidden = !split || n !== 2;
    syncPerso2(root);
  }
  function buildDog2(root){
    if (root.querySelector('#dog2Wrap')) return;
    var src = root.querySelector('#optGroups');
    if (!src) return;
    var clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(function(n){ n.removeAttribute('id'); });
    // Los links de guia (Size guide / See all colors) VIAJAN al clon. Antes se borraban aca y Dog 2
    // quedaba sin forma de abrir las guias justo cuando mas se necesitan: es el panel donde el
    // comprador elige un talle para un SEGUNDO perro, distinto del primero. No hay colision de ids
    // porque los modales son unicos y viven fuera de #optGroups, y el handler es delegado sobre
    // #pdp-factory [data-size-guide-open] / [data-colors-open]. Medido el 08/08.
    clone.querySelectorAll('.opt-group').forEach(function(g){ g.classList.add('d2-group'); g.classList.remove('opt-group'); });
    var wrap = document.createElement('div');
    wrap.id = 'dog2Wrap';
    wrap.hidden = true;
    wrap.appendChild(clone);
    src.parentNode.insertBefore(wrap, src.nextSibling);
    var bar = document.createElement('div');
    bar.id = 'dogTabs';
    bar.className = 'dog-tabs';
    bar.hidden = true;
    [1, 2].forEach(function(n){
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.dog = n;
      b.textContent = 'Dog ' + n;
      if (n === 1) b.classList.add('on');
      bar.appendChild(b);
    });
    src.parentNode.insertBefore(bar, src);
    var p1 = root.querySelector('#pdpPerso');
    if (p1) {
      var p2 = p1.cloneNode(true);
      p2.id = 'pdpPerso2';
      p2.dataset.required = '0';
      p2.hidden = true;
      // El clon NO hereda .perso-gated: esa clase oculta con max-height:0 y obligaba a acordarse
      // de la clase .open para revelarlo. Dentro del panel de Dog 2 alcanza con [hidden].
      p2.classList.remove('open', 'invalid', 'perso-gated');
      p2.removeAttribute('data-requires-bump');
      var i2 = p2.querySelector('#pdpPersoInput');
      if (i2) { i2.id = 'pdpPersoInput2'; i2.removeAttribute('name'); i2.value = ''; }
      var l2 = p2.querySelector('.perso-label');
      if (l2) l2.setAttribute('for', 'pdpPersoInput2');
      var s2 = p2.querySelector('.perso-label span');
      if (s2) s2.textContent = "Dog 2's name";
      var r2 = p2.querySelector('.perso-req'); if (r2) r2.textContent = 'OPTIONAL';
      var c2 = p2.querySelector('.perso-count'); if (c2) c2.remove();
      var s1 = p1.querySelector('.perso-label span');
      if (s1 && !p1.dataset.origLabel) p1.dataset.origLabel = s1.textContent;
      // Los DOS nombres viven abajo, pegados uno al otro (08/08, pedido de Emilio): el de Dog 2
      // adentro de #dog2Wrap quedaba arriba de la correa y el de Dog 1 abajo del bump — dos
      // alturas distintas para el mismo campo. Ahora los dos cuelgan del mismo lugar y el tab
      // decide cual se ve (syncPerso2), no la posicion en el DOM.
      p1.parentNode.insertBefore(p2, p1.nextSibling);
    }
  }
  function resolveDog2(root){
    var variants = getVariantsData(root);
    if (!variants || !variants.length) return;
    var vals = [];
    root.querySelectorAll('#dog2Wrap .d2-group').forEach(function(group){
      var pos = parseInt(group.dataset.optionPosition, 10);
      var sel = group.querySelector('.opt-value.selected');
      vals[pos - 1] = sel ? sel.dataset.value : null;
    });
    root.__dog2 = findVariant(variants, vals);
  }
  function dog2Color(root){
    var sel = root.querySelector('#dog2Wrap .d2-group[data-is-size="false"] .opt-value.selected');
    if (!sel) return null;
    var dot = sel.querySelector('.sw-dot');
    return { value: sel.dataset.value, hex: dot ? (dot.style.background || dot.style.backgroundColor) : '' };
  }
  // El input de Dog 2 se revela con [hidden] solo (el clon ya no es .perso-gated), y sigue al
  // checkbox de la placa: sin placa no hay donde imprimir el nombre.
  function syncPerso2(root){
    var on = root.classList.contains('pdp-split');
    var tab = parseInt(root.dataset.dogTab, 10) || 1;
    var gate = root.querySelector('#pdpBump input[data-bump-variant]');
    var gateOn = !gate || gate.checked;
    var p1 = root.querySelector('#pdpPerso');
    if (p1 && p1.dataset.origLabel) {
      var s1 = p1.querySelector('.perso-label span');
      if (s1) s1.textContent = on ? "Dog 1's name" : p1.dataset.origLabel;
    }
    var p2 = root.querySelector('#pdpPerso2');
    if (!p2) return;
    // Los dos nombres ocupan el MISMO lugar: se ve el del perro cuyo tab esta activo.
    p2.hidden = !(on && gateOn && tab === 2);
    if (!on) { var i2 = p2.querySelector('#pdpPersoInput2'); if (i2) i2.value = ''; }
  }
  // Cada bloque va en su propio safe(): antes una sola excepcion cortaba el resto y dejaba la
  // PDP a medio aplicar (tabs visibles, placa sin FREE, input 2 sin revelar). 08/08.
  function toggleSplit(root, on){
    on = !!on;
    if (on) safe(function(){ buildDog2(root); });
    root.classList.toggle('pdp-split', on);
    safe(function(){
      var bar = root.querySelector('#dogTabs');
      if (bar) bar.hidden = !on;
    });
    // Placa: con 2 Dogs las DOS gratis; el display acompana lo que cobra el automatic discount.
    safe(function(){
      root.querySelectorAll('#pdpBump .bump-price').forEach(function(bp){
        var now = bp.querySelector('.bp-now');
        if (!now) return;
        if (!now.dataset.orig) now.dataset.orig = now.textContent.trim();
        // El compare-at ($10) se esconde con 2 Dogs: al lado de "FREE" y del $6 tachado son tres
        // precios para una sola placa. Vuelve solo al salir del split.
        var was = bp.querySelector('.bp-was');
        if (was) was.hidden = on;
        // El precio que la placa DEJA de costar se dibuja en su propio nodo, no envolviendo el
        // innerHTML: asi no se anidan los <s>.
        var freeWas = bp.querySelector('.bp-free-was');
        if (on) {
          now.textContent = 'FREE';
          if (!freeWas) {
            freeWas = document.createElement('s');
            freeWas.className = 'bp-free-was';
            bp.appendChild(freeWas);
          }
          freeWas.textContent = now.dataset.orig.replace(/^\+/, '');
          freeWas.hidden = false;
        } else {
          now.textContent = now.dataset.orig;
          if (freeWas) freeWas.hidden = true;
        }
      });
    });
    // La tarjeta dice lo que el carrito manda: con 2 Dogs van DOS correas (una por perro).
    safe(function(){
      var gl = root.querySelector('#pdpGift');
      if (!gl) return;
      var gt = gl.querySelector('.gl-title');
      var tn = gt && gt.firstChild;
      if (tn && tn.nodeType === 3) {
        if (!gt.dataset.orig) gt.dataset.orig = tn.nodeValue;
        tn.nodeValue = on ? ('2x ' + gt.dataset.orig.trim() + ' ') : gt.dataset.orig;
      }
      var gs = gl.querySelector('.gl-price s');
      var gcents = parseInt(gl.dataset.giftValue, 10) || 0;
      if (gs && gcents > 0) {
        if (!gs.dataset.orig) gs.dataset.orig = gs.textContent;
        gs.textContent = on ? money(gcents * 2) : gs.dataset.orig;
      }
    });
    if (on) safe(function(){ resolveDog2(root); });
    safe(function(){ setDogTab(root, 1); });
    safe(function(){ updateDogTabs(root); });
    safe(function(){ syncPerso2(root); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#pdp-factory #dogTabs button');
    if (!btn) return;
    safe(function(){ setDogTab(btn.closest('#pdp-factory'), parseInt(btn.dataset.dog, 10) || 1); });
  });
  document.addEventListener('input', function(e){
    var input = e.target.closest('#pdp-factory #pdpPersoInput, #pdp-factory #pdpPersoInput2');
    if (!input) return;
    safe(function(){ updateDogTabs(input.closest('#pdp-factory')); });
  });
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#pdp-factory #dog2Wrap .opt-value');
    if (!btn) return;
    safe(function(){
      var group = btn.closest('.d2-group');
      if (!group) return;
      group.querySelectorAll('.opt-value').forEach(function(b){ b.classList.remove('selected'); });
      btn.classList.add('selected');
      var label = group.querySelector('[data-opt-label]');
      if (label) label.textContent = (group.dataset.optionName || '').toUpperCase() + ': ' + btn.dataset.value;
      var r2 = btn.closest('#pdp-factory');
      resolveDog2(r2);
      updateDogTabs(r2);
    });
  });
  document.addEventListener('change', function(e){
    var input = e.target.closest('#pdp-factory #pdpBump input[data-bump-variant]');
    if (!input) return;
    safe(function(){ syncPerso2(input.closest('#pdp-factory')); });
  });

  function selectOption(btn){
    var group = btn.closest('.opt-group');
    if (!group) return;
    group.querySelectorAll('.opt-value').forEach(function(b){ b.classList.remove('selected'); });
    btn.classList.add('selected');
    updateGroupLabel(group, btn.dataset.value);
    safe(function(){ updateGiftColor(btn.closest('#pdp-factory'), group.dataset.optionName, btn.dataset.value); });
    safe(function(){ updateXbumpColor(btn.closest('#pdp-factory'), group.dataset.optionName, btn.dataset.value); });
    safe(function(){ updateDogTabs(btn.closest('#pdp-factory')); });
    resolveVariant(btn.closest('#pdp-factory'));
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#pdp-factory .opt-value');
    if (!btn) return;
    safe(function(){ selectOption(btn); });
  });
  // Sync variant id / price / CTA state to the default-selected size on load
  safe(function(){
    document.querySelectorAll('#pdp-factory').forEach(function(root){ resolveVariant(root); });
  });

  // ---- Size guide modal ----
  function openSizeGuide(root){
    var modal = root.querySelector('#sizeGuideModal');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeSizeGuide(root){
    var modal = root.querySelector('#sizeGuideModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('#pdp-factory [data-size-guide-open]');
    if (openBtn) { safe(function(){ openSizeGuide(openBtn.closest('#pdp-factory')); }); return; }
    var closeBtn = e.target.closest('#pdp-factory [data-size-guide-close]');
    if (closeBtn) { safe(function(){ closeSizeGuide(closeBtn.closest('#pdp-factory')); }); return; }
    // Colours modal (2026-08-05): same shell, different id.
    var cOpen = e.target.closest('#pdp-factory [data-colors-open]');
    if (cOpen) { safe(function(){ var m = cOpen.closest('#pdp-factory').querySelector('#colorsModal'); if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); } }); return; }
    var cClose = e.target.closest('#pdp-factory [data-colors-close]');
    if (cClose) { safe(function(){ var m = cClose.closest('#pdp-factory').querySelector('#colorsModal'); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); } }); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    safe(function(){
      // Cierra CUALQUIER modal con el shell del size guide (incluye #colorsModal, que
      // comparte la clase a proposito) — cerrar por id dejaba al de colores sin Escape.
      document.querySelectorAll('#pdp-factory .size-guide-modal.is-open').forEach(function(modal){
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      });
    });
  });

  // ---- [data-scroll-to="<id sin #>"]: click/Enter/Space scrollea a ese bloque del factory.
  // Usos: el rating -> reviews (original), y la fomo-pill -> tiers (2026-08-08).
  // ⚠️ El valor va SIN '#' — es la convencion original de este atributo. Al agregar la pill se
  // escribio "#tiers" y esta funcion armaba '##tiers': SyntaxError en cada click, tragado por
  // safe(). El scroll igual andaba (lo hacia un segundo handler que se agrego por error), asi
  // que a ojo no se veia: aparecio en la consola. Un atributo, un handler.
  function scrollToReviews(el){
    var root = el.closest('#pdp-factory');
    var target = root.querySelector('#' + el.dataset.scrollTo);
    // scrollSuave y no scrollIntoView({behavior:'smooth'}): la duracion del nativo la fija el
    // navegador y en un salto largo se siente lento. Aca es fija (520ms) con easeInOutCubic.
    if (target) scrollSuave(target);
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest('#pdp-factory [data-scroll-to]');
    if (!el) return;
    safe(function(){ scrollToReviews(el); });
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest('#pdp-factory [data-scroll-to]');
    if (!el) return;
    e.preventDefault();
    safe(function(){ scrollToReviews(el); });
  });

  // ---- Review tabs ----
  document.addEventListener('click', function(e){
    var tabEl = e.target.closest('#pdp-factory .rtab');
    if (!tabEl) return;
    safe(function(){
      var root = tabEl.closest('#pdp-factory');
      var tab = tabEl.dataset.rtab;
      root.querySelectorAll('.rtab').forEach(function(b){ b.classList.toggle('active', b === tabEl); });
      // "__all__" es la pestaña por defecto y no filtra: muestra el muro entero. El resto
      // filtra por tema, igual que antes. Ver el comentario del liquid.
      var todas = (tab === '__all__');
      root.querySelectorAll('.reviews-grid .review').forEach(function(card){
        card.classList.toggle('rhide', !todas && card.dataset.reviewTab !== tab);
      });
    });
  });

  // Personalization: live counter, and the error clears as soon as the person starts fixing it.
  // Delegated like every other listener here, so it survives a section re-render.
  document.addEventListener('input', function(e){
    var input = e.target.closest('#pdp-factory #pdpPersoInput');
    if (!input) return;
    safe(function(){
      var box = input.closest('.perso');
      var counter = box.querySelector('[data-perso-count]');
      if (counter) { counter.textContent = input.value.length + '/' + (input.dataset.persoMax || ''); }
      if (input.value.trim()) { box.classList.remove('invalid'); }
    });
  });

  // ---- AJAX add to cart (Shopify Cart API) ----
  function showToast(root, msg){
    var toast = root.querySelector('#pdpToast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function(){ toast.classList.remove('show'); }, 2200);
  }
  // Personalization: returns false to abort the add, null when the product has no field, or
  // {key, value, field} to hand to whichever cart path runs.
  function checkPerso(root){
    var box = root.querySelector('#pdpPerso');
    if (!box) return null;
    var input = box.querySelector('#pdpPersoInput');
    if (!input) return null;

    var field = input.getAttribute('name') || '';
    var key = field.replace(/^properties\[/, '').replace(/\]$/, '');

    // Gated (2026-08-02): el campo cuelga del bump. Si el bump existe y no esta tildado no hay
    // nada que personalizar, asi que ni se valida ni viaja. Devuelve skip en vez de null para que
    // addToCart sepa que TIENE que sacar el input vacio del FormData: si no, la orden llega con una
    // propiedad en blanco, que es el mismo defecto que ya arreglamos para el campo opcional.
    if (box.dataset.requiresBump === '1') {
      var gate = root.querySelector('#pdpBump input[data-bump-variant]');
      if (!gate || !gate.checked) {
        box.classList.remove('invalid');
        return { key: key, value: '', field: field, skip: true, onBump: true };
      }
    }

    var value = (input.value || '').trim();
    var err = box.querySelector('[data-perso-err]');
    function reject(msg){
      box.classList.add('invalid');
      if (err) err.textContent = msg;
      try { input.focus({ preventScroll: false }); } catch (e) { input.focus(); }
      return false;
    }

    if (!value) {
      if (box.dataset.required === '1') {
        var what = (box.querySelector('.perso-label span') || {}).textContent || 'this field';
        return reject('Please fill in ' + what.toLowerCase() + ' before adding to cart.');
      }
    } else if (box.dataset.pattern) {
      // Anchored here so a partial match cannot pass. Guardrail against typos the printer cannot
      // set, not validation to be trusted: the browser is not the authority.
      var re;
      try { re = new RegExp('^(?:' + box.dataset.pattern + ')$'); } catch (e) { re = null; }
      if (re && !re.test(value)) { return reject('Please use letters, numbers and spaces only.'); }
    }

    box.classList.remove('invalid');
    // onBump: cuando el campo cuelga del bump, el nombre es del PRODUCTO DEL BUMP (la placa es lo
    // que se imprime), no del arnes. La propiedad tiene que viajar en esa linea o el que arma el
    // pedido la busca en el item equivocado.
    return { key: key, value: value, field: field, onBump: box.dataset.requiresBump === '1' };
  }

  function addToCart(root){
    var form = root.querySelector('#pdp-form');
    var btn = root.querySelector('#ctaMain');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');

    // Order bump (2026-08-02). With the bump ON we cannot use the FormData path: a product form
    // carries ONE id + quantity, and the bump is a DIFFERENT product that has to arrive as its own
    // line item. /cart/add.js takes an `items` array, but only as JSON, so the two paths are
    // genuinely different requests and not a flag on the same one.
    // The FormData path is left byte-for-byte as it was: a product with no bump keeps the exact
    // request it had before this change.
    // Personalization (2026-08-02). Validated BEFORE the request so a required-but-empty name
    // stops here with the field focused, instead of arriving at checkout as a blank property.
    var perso = checkPerso(root);
    if (perso === false) {
      // Con tabs, el input invalido puede estar en el panel oculto: se muestra antes de enfocar.
      if (root.classList.contains('pdp-split')) {
        setDogTab(root, 1);
        var pErr = root.querySelector('#pdpPersoInput');
        if (pErr) pErr.focus();
      }
      return;
    }

    var bumpInput = root.querySelector('#pdpBump input[data-bump-variant]');
    // free_gift (2026-08-02). El regalo NO se elige: si el bloque esta en la pagina, su linea va
    // en el carrito siempre. Por eso mira el elemento, no un checkbox.
    var giftEl = root.querySelector('#pdpGift[data-gift-variant]');
    var bumpItem = null, giftItem = null;
    if (bumpInput && bumpInput.checked) {
      bumpItem = { id: parseInt(bumpInput.dataset.bumpVariant, 10), quantity: parseInt(bumpInput.dataset.bumpQty || 1, 10) };
    }
    // order_bumps (2026-08-08): cada lite tildado es su propia linea, sin propiedades ni split.
    var xbumpItems = [];
    root.querySelectorAll('.bump-lite input[data-xbump-variant]').forEach(function(xi){
      if (xi.checked) xbumpItems.push({ id: parseInt(xi.dataset.xbumpVariant, 10), quantity: parseInt(xi.dataset.xbumpQty || 1, 10) });
    });
    if (giftEl) {
      // per_unit (08/08): el regalo escala con la qty del hero (bug #1259: 2 arneses, 1 correa).
      var giftUnits = parseInt(giftEl.dataset.giftQty || 1, 10);
      if (giftEl.dataset.giftPerUnit === '1') {
        var mainQtyEl = form.querySelector('[data-quantity]');
        giftUnits = giftUnits * (parseInt((mainQtyEl && mainQtyEl.value) || 1, 10) || 1);
      }
      giftItem = { id: parseInt(giftEl.dataset.giftVariant, 10), quantity: giftUnits };
    }
    // 2 Dogs: la 2da variante tiene que existir y estar disponible.
    var splitOn = root.classList.contains('pdp-split');
    var dog2 = null;
    if (splitOn) {
      resolveDog2(root);
      dog2 = root.__dog2;
      if (!dog2 || dog2.available === false) {
        setDogTab(root, 2);
        showToast(root, "Dog 2: that combo is sold out - pick another size or color");
        return;
      }
    }
    var opts;
    if (bumpItem || giftItem || dog2 || xbumpItems.length) {
      var mainId = form.querySelector('[data-variant-id]');
      var mainQty = form.querySelector('[data-quantity]');
      var heroItem = { id: parseInt(mainId && mainId.value, 10), quantity: parseInt((mainQty && mainQty.value) || 1, 10) };
      // The FormData path carries properties[] for free; this one has to copy them across, onto
      // whichever line the text actually belongs to. A gated field describes the bump product (the
      // patch is what gets printed), an ungated one describes the hero.
      if (perso && perso.value) {
        var target = (perso.onBump && bumpItem) ? bumpItem : heroItem;
        target.properties = {};
        target.properties[perso.key] = perso.value;
      }
      // properties[_Color] / properties[_Color Hex] (2026-08-05, revisado 2026-08-06): el
      // camino FormData las lleva gratis; este las copia a mano sobre el hero, que es el item
      // que tiene color.
      var colorPropJson = form.querySelector('[data-color-property]');
      if (colorPropJson && !colorPropJson.disabled && colorPropJson.value) {
        heroItem.properties = heroItem.properties || {};
        heroItem.properties['_Color'] = colorPropJson.value;
      }
      var colorHexPropJson = form.querySelector('[data-color-hex-property]');
      if (colorHexPropJson && !colorHexPropJson.disabled && colorHexPropJson.value) {
        heroItem.properties = heroItem.properties || {};
        heroItem.properties['_Color Hex'] = colorHexPropJson.value;
      }
      var hero2Item = null, gift2Item = null, bump2Item = null;
      if (dog2) {
        hero2Item = { id: dog2.id, quantity: 1 };
        var d2c = dog2Color(root);
        if (d2c && d2c.value) {
          hero2Item.properties = { '_Color': d2c.value };
          if (d2c.hex) hero2Item.properties['_Color Hex'] = d2c.hex;
        }
        if (giftItem) {
          // Una correa por perro, cada una del color del SUYO (colormap).
          giftItem.quantity = 1;
          var d2map = getGiftColormap(root);
          var d2entry = d2c && d2map && d2map[d2c.value];
          gift2Item = { id: d2entry ? d2entry.id : giftItem.id, quantity: 1 };
        }
        if (bumpItem) {
          var n2el = root.querySelector('#pdpPersoInput2');
          var n2 = n2el ? (n2el.value || '').trim() : '';
          if (n2) {
            bump2Item = { id: bumpItem.id, quantity: 1, properties: {} };
            bump2Item.properties[(perso && perso.key) || 'Name'] = n2;
          }
        }
      }
      var items = [ heroItem ];
      if (hero2Item) items.push(hero2Item);
      if (bumpItem) items.push(bumpItem);
      if (bump2Item) items.push(bump2Item);
      xbumpItems.forEach(function(x){ items.push(x); });
      // El regalo va ULTIMO a proposito: asi el carrito lo muestra debajo de lo que se pago, que
      // es como se lee un regalo. Arriba parece el producto principal.
      if (giftItem) items.push(giftItem);
      if (gift2Item) items.push(gift2Item);
      var payload = { items: items };
      if (drawer) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
      opts = { method: 'POST', body: JSON.stringify(payload),
               headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    } else {
      var fd = new FormData(form);
      // An empty optional field would otherwise reach the order as a blank property and show up on
      // the packing slip as a line with nothing after the colon.
      if (perso && (!perso.value || perso.skip)) { fd.delete(perso.field); }
      if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
      opts = { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } };
    }

    if (btn) btn.setAttribute('disabled', '');
    fetch('/cart/add.js', opts)
      .then(function(r){ if (!r.ok) throw new Error('cart error'); return r.json(); })
      .then(function(item){
        showToast(root, 'Added to cart ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var opened = false;
        if (drawer && item && item.sections) { try { drawer.renderContents(item);
        drawer.classList.remove('is-empty');
        var di = drawer.querySelector('.drawer__inner'); if (di) di.classList.remove('is-empty'); opened = true; } catch (e) { console.error('[pdp-factory]', e); } }
        if (!opened) { window.location.href = '/cart'; }
      })
      .catch(function(){ showToast(root, 'Could not add to cart'); })
      .finally(function(){ if (btn) btn.removeAttribute('disabled'); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#pdp-factory #ctaMain, #pdp-factory #ctaSticky, #pdp-factory [form="pdp-form"]');
    if (!btn) return;
    e.preventDefault();
    safe(function(){ addToCart(btn.closest('#pdp-factory')); });
  });

  // ---- Sold badge: dismissible, stays hidden via localStorage ----
  var SOLD_DISMISS_KEY = 'pdpSoldBadgeDismissed';
  function isSoldBadgeDismissed(){
    try { return localStorage.getItem(SOLD_DISMISS_KEY) === '1'; } catch (e) { return false; }
  }
  function dismissSoldBadge(badge){
    if (!badge) return;
    badge.style.display = 'none';
    try { localStorage.setItem(SOLD_DISMISS_KEY, '1'); } catch (e) {}
  }
  document.addEventListener('click', function(e){
    var closeBtn = e.target.closest('#pdp-factory [data-badge-sold-close]');
    if (!closeBtn) return;
    safe(function(){ dismissSoldBadge(closeBtn.closest('.badge-sold')); });
  });
  safe(function(){
    if (!isSoldBadgeDismissed()) return;
    document.querySelectorAll('#pdp-factory .badge-sold').forEach(function(badge){ badge.style.display = 'none'; });
  });

  // ---- Subtle motion: single rAF clock (resilient to theme timer throttling) ----
  safe(function(){
    var soldEl = document.querySelector('#soldBadge .badge-sold-text');
    var stickyEl = document.querySelector('#pdp-factory .sticky-atc');
    var ctaAnchor = document.getElementById('ctaMain');
    if (stickyEl && ctaAnchor) {
      // La sticky aparece SOLO cuando el CTA quedo arriba del viewport, o sea cuando ya lo
      // pasaste. Dos bugs corregidos el 2026-08-08, los dos medidos:
      //
      // 1. La condicion era `!isIntersecting` a secas, y eso la mostraba tambien ARRIBA DE TODO
      //    (en y=0, con el CTA 1800px mas abajo): apenas cargaba la pagina habia una barra de
      //    "Add to cart" tapando el hero, y desaparecia al BAJAR hasta el CTA. Al reves de lo
      //    que uno espera.
      // 2. Con IntersectionObserver solo no alcanza: en un scroll rapido o un salto largo, el
      //    CTA pasa de "fuera por arriba" a "fuera por abajo" sin intersecar en ningun frame
      //    muestreado. `isIntersecting` no cambia, el observer NO dispara, y la clase queda
      //    pegada en el estado viejo — la sticky visible arriba de todo. Es exactamente el
      //    sintoma que reporto Emilio ("scrolleo para arriba y se ve").
      //
      // Por eso se mide la posicion en cada scroll, con rAF para no leer layout por evento.
      var tick = false;
      var syncSticky = function(){
        tick = false;
        stickyEl.classList.toggle('is-visible', ctaAnchor.getBoundingClientRect().bottom < 0);
      };
      var onScroll = function(){
        if (tick) return;
        tick = true;
        requestAnimationFrame(syncSticky);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      syncSticky();
    }
    var cdEl = document.getElementById('countdown');
    var urgencyEl = document.querySelector('#pdp-factory .final .urgency');

    var start = Date.now();
    // Read the base count AND the "in the last X" wording from the metafield text itself
    // (was hardcoded to 142 / "in the last 24 hours" — a merchant editing the metafield to say
    // "last week" saw it overwritten back to "24 hours" a second after paint, by this code).
    var soldTemplate = soldEl ? soldEl.textContent.replace(/^\s*⚡\s*/, '').trim() : '';
    var soldMatch = soldTemplate.match(/\d+/);
    var soldBase = soldMatch ? parseInt(soldMatch[0], 10) : 142;
    var soldSuffix = soldMatch ? soldTemplate.slice(soldMatch.index + soldMatch[0].length).replace(/^\+?\s*sold\s*/i, '').trim() : 'in the last 24 hours';
    if (!soldSuffix) soldSuffix = 'in the last 24 hours';

    var CD_KEY = 'pdpGiftsExpiry';
    var CD_WINDOW = 4 * 60 * 60 * 1000;
    var expiry = parseInt(localStorage.getItem(CD_KEY), 10);
    if (!expiry || isNaN(expiry) || expiry <= Date.now()) { expiry = Date.now() + CD_WINDOW; localStorage.setItem(CD_KEY, expiry); }

    var stockTemplate = urgencyEl ? (urgencyEl.dataset.template || urgencyEl.textContent.trim()) : '';
    var stockMatch = stockTemplate.match(/\d+/);
    var stockStart = stockMatch ? parseInt(stockMatch[0], 10) : 14;

    // FOMO widgets that DO need a clock (viewers breathe, pill counts down, pops rotate).
    // The stock badge is NOT here on purpose — see updateFomoStock(), driven by resolveVariant().
    var viewersEl = document.querySelector('#pdp-factory [data-fomo-viewers]');
    var fomoCdEl = document.querySelector('[data-fomo-cd]');
    var popEl = document.getElementById('fomoPop');
    var popsData = null;
    try { var pj = document.getElementById('fomo-pops-json'); if (pj) popsData = JSON.parse(pj.textContent); } catch(e){}
    var dayKey = fomoDayKey;
    var lastViewers = -1, lastFomoCd = '', lastPopIdx = -1;

    function pad(n){ return String(n).padStart(2,'0'); }
    var lastSold = -1, lastCd = '', lastStock = -1;

    function frame(){
      var now = Date.now();
      var elapsed = now - start;

      if (soldEl) {
        var sold = soldBase + Math.floor(elapsed / 40000);
        if (sold !== lastSold) { soldEl.innerHTML = '⚡ <b>' + sold + '+ sold</b> ' + soldSuffix; lastSold = sold; }
      }
      if (cdEl) {
        if (now >= expiry) { expiry = now + CD_WINDOW; localStorage.setItem(CD_KEY, expiry); }
        var ms = expiry - now;
        var txt = pad(Math.floor(ms/3600000)) + ':' + pad(Math.floor((ms%3600000)/60000)) + ':' + pad(Math.floor((ms%60000)/1000));
        if (txt !== lastCd) { cdEl.textContent = txt; lastCd = txt; }
      }
      if (urgencyEl && stockMatch) {
        var stock = Math.max(3, stockStart - Math.floor(elapsed / 45000));
        if (stock !== lastStock) { urgencyEl.innerHTML = '<span class="dot"></span> ' + stockTemplate.replace(stockMatch[0], stock); lastStock = stock; }
      }

      // Viewers: base seeded per hour, breathing +-2 every ~20s so it feels alive.
      if (viewersEl) {
        var vMin = parseInt(viewersEl.dataset.min, 10), vMax = parseInt(viewersEl.dataset.max, 10);
        var hourSeed = seedHash('v' + Math.floor(now / 3600000));
        var vBase = vMin + (hourSeed % Math.max(1, vMax - vMin));
        var v = Math.max(vMin, vBase + [0, 1, 2, 1, 0, -1][Math.floor(elapsed / 20000) % 6]);
        if (v !== lastViewers) { viewersEl.textContent = v; lastViewers = v; }
      }

      // Floating pill countdown: SAME persisted expiry as the gifts countdown, on purpose.
      if (fomoCdEl) {
        var pms = Math.max(0, expiry - now);
        var ptxt = pad(Math.floor(pms/3600000)) + ':' + pad(Math.floor((pms%3600000)/60000)) + ':' + pad(Math.floor((pms%60000)/1000));
        if (ptxt !== lastFomoCd) { fomoCdEl.textContent = ptxt; lastFomoCd = ptxt; }
      }

      // Sales pop: one every 24s, visible 6s, first one at 7s. Minutes-ago is seeded per
      // entry+day so the same purchase never changes its own timestamp.
      if (popEl && popsData && popsData.length) {
        var cycle = Math.floor((elapsed - 7000) / 24000);
        var inWindow = elapsed > 7000 && ((elapsed - 7000) % 24000) < 6000;
        if (inWindow) {
          var idx = ((cycle % popsData.length) + popsData.length) % popsData.length;
          if (idx !== lastPopIdx) {
            var entry = popsData[idx];
            var mins = 2 + (seedHash('p' + idx + dayKey) % 17);
            popEl.innerHTML = '<b>' + entry[0] + '</b> from ' + entry[1] + ' just ordered · <span>' + mins + ' min ago</span>';
            lastPopIdx = idx;
          }
          popEl.classList.add('show');
        } else { popEl.classList.remove('show'); if (!inWindow && cycle >= 0) lastPopIdx = -1; }
      }
    }
    frame();
    setInterval(frame, 1000);
  });
  }
  if (document.readyState === 'complete') { boot(); }
  else { window.addEventListener('load', boot); document.addEventListener('DOMContentLoaded', boot); }
})();
